<script lang="ts">
  import { params } from '@roxi/routify'
  import NoSubscriptionUserTopBarPage from '../Navigation/TopLevelPages/NoSubscriptionUserTopBarPage.svelte'
  import { app_user } from '../Users/observables'
  import Retro from '../Game/Retro.svelte'
  import JoinOrganization from '../Organizations/Join.svelte'
  import decodeWith from '../shared/firebase/decodeHelper'
  import * as T from 'io-ts'
  const ParamsT = T.type({
    join: T.string,
  })
  const org_uid: string | undefined = decodeWith(ParamsT, $params)?.join
</script>

{#if $app_user.state === 'Loading'}
  <p>Loading...</p>
{:else if $app_user?.state === 'Authed'}
  <Retro user={$app_user} />
{:else if !org_uid}
  <p>There was an error decoding the organisation id.</p>
{:else}
  <NoSubscriptionUserTopBarPage>
    <JoinOrganization {org_uid} />
  </NoSubscriptionUserTopBarPage>
{/if}
